import _request from '@/utils/request';
import { _getQuerystr } from '@/utils/commonUtils';

// 咨询师查询工作日历（排班+预约）
export async function doctorGetConsultantScheduling(params) {
  return await _request({
    method: 'GET',
    url: `/consultant/scheduling${_getQuerystr(params)}`
  });
}

// 查询来访者列表
export async function doctorGetStaffList() {
  return await _request({
    method: 'GET',
    url: `/consultant/staff/list`
  });
}

// 添加可预约时段
export async function doctorAddAppointTimeslot(data) {
  return await _request({
    method: 'POST',
    url: `/consultant/appointTimeslot`,
    data
  });
}

// 咨询师添加预约
export async function doctorAddAppoint(data) {
  return await _request({
    method: 'POST',
    url: `/consultant/appoint`,
    data
  });
}

// 咨询师删除可预约时段
export async function doctorDeleteAppointTimeslot(timeslotId) {
  return await _request({
    method: 'DELETE',
    url: `/consultant/appointTimeslot/${timeslotId}`
  });
}

// 咨询师取消预约
export async function doctorDeleteAppoint(appointId) {
  return await _request({
    method: 'DELETE',
    url: `/consultant/appoint/${appointId}`
  });
}

// 咨询师查询聊天记录
export async function doctorGetChatMsg(params) {
  return await _request({
    method: 'GET',
    url: `/consultant/chat/msgPage${_getQuerystr(params)}`
  });
}

// 咨询师查询（已绑定）STAFF列表
export async function doctorGetChatStaffList(params) {
  return await _request({
    method: 'GET',
    url: `/consultant/staff/chatStaffList${_getQuerystr(params)}`
  });
}

// 咨询师查询STAFF列表 分页接口
export async function doctorGetStaffListPage(params) {
  return await _request({
    method: 'GET',
    url: `/consultant/staff/pageChatStaff${_getQuerystr(params)}`
  });
}

// 咨询师聊天文件上传
export async function doctorUploadChatFile(resourceType, data) {
  return await _request({
    method: 'POST',
    url: `/consultant/upload/${resourceType}`,
    data,
    type: 'upload'
  });
}

// 咨询师聊天文件上传V2
export async function doctorUploadChatFileV2(resourceType, data) {
  return await _request({
    method: 'POST',
    url: `/consultant/upload/v2/${resourceType}`,
    data,
    type: 'upload'
  });
}

// 咨询师申请修改资料
export async function consultantInfoApply(params) {
  const url = '/consultant/infoApply/add';
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// 咨询师撤销修改资料申请
export async function consultantRevokeInfoApply(applyId) {
  const url = `/consultant/infoApply/${applyId}/revoke`;
  return await _request({
    method: 'POST',
    url,
    data: applyId,
  })
}

// 咨询师分页查询资料申请修改记录
export async function consultantSearchInfoApply(params) {
  const url = `/consultant/infoApply/page${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [咨询师] 咨询完成确认
export async function consultantConsultCompleted(params) {
  const url = `/consultant/consult/consultRecodeCompleted`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// [咨询师] 关闭音视频房间
export async function consultantLeaveRoom(params) {
  const url = `/consultant/appoint/leaveRoom`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// [咨询师]匿名拨号
export async function consultantAnonymousCall(params) {
  let url = ''
  const { staffId } = params;
  if (!staffId) {
    url = `/consultant/appoint/bindSecretNo/noStaff`
  } else {
    url = `/consultant/appoint/bindSecretNo/${params.staffId}`;
  }
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// [咨询师]撤回消息
export async function consultantChatWithdraw(params) {
  const url = `/consultant/chat/withdraw`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// [咨询师]撤回消息V2
export async function consultantChatWithdrawV2(chatMsgId) {
  const url = `/consultant/chat/v2/withdraw/${chatMsgId}`;
  return await _request({
    method: 'POST',
    url,
  })
}

// [咨询师]预约列表
export async function getConsultantAppointmentList(params) {
  const url = `/consultant/appointment/page${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  });
}

// [咨询师]预约详情
export async function getConsultantAppointmentDetail(id) {
  const url = `/consultant/appointment/${id}`;
  return await _request({
    method: 'GET',
    url
  });
}

// [咨询师] 完成咨询
export async function consultantCompleteAppointment(id, params) {
  const url = `/consultant/appointment/${id}/complete`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}


// 咨询师 查询风险详情（含log）
export async function getRiskDetail(params) {
  const url = `/consultant/risk/info${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  })
}

// 咨询师 确认风险
export async function confirmRisk(params) {
  const url = `/consultant/risk/${params.riskId}/confirmed`;
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// 咨询师 排除风险
export async function excludeRisk(params) {
  const url = `/consultant/risk/${params.riskId}/exclusion`;
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// 咨询师 干预风险
export async function interveneRisk(params) {
  const url = `/consultant/risk/${params.riskId}/intervening`;
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// 咨询师获取RTC token
export async function getDoctorRTCToken(params) {
  const url = `/consultant/RTC/createToken${_getQuerystr(params)}`
  return await _request({
    method: 'GET',
    url
  });
}

// 医生登录
export async function loginByDoctor(data) {
  const url = `/consultant/autoRegisterLogin`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// 咨询师发送短信验证码
export async function sendDoctorVerifyCode(telephone) {
  const url = `/consultant/sendVerifyCode/${telephone}`;
  return await _request({
    method: 'POST',
    url
  });
}

/**
 * 通知员工发起音视频聊天
 * @param {*} roomUrl  
 * @param {*} toUserId  
 * @returns 
 */
export async function createAppointRoomSuccess(data) {
  const url = `/consultant/appoint/room`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// 舒小辅获取所有咨询师信息
export async function getAllConsultantList() {
  const url = `/consultant/list`;
  return await _request({
    method: 'GET',
    url
  });
}

/**
 *  舒小辅手动绑定咨询师
 * @param {*} data consultantId staffId
 * @returns 
 */
export async function reBindBySiuvo(data) {
  const url = `/consultant/shuXiaoFu/reBind`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// 批量预约
export async function batchAdd(data) {
  const url = `/consultant/appoint/batchAdd`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// 咨询师通过authId查询STAFF详情
export async function doctorGetPatientInfo(params) {
  const url = `/consultant/staff/info${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  });
}

// [咨询师]查询来访者的form list
export async function doctorGetPatientFormList(params) {
  const url = `/consultant/task/formList${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  });
}

// 咨询师通过authId查询基本信息
export async function doctorGetSelfInfo(id) {
  const url = `/consultant/info?authId=${id}`;
  return await _request({
    method: 'GET',
    url
  });
}

// 咨询师查询量表list
export async function getQuestionnaireList() {
  const url = `/consultant/questionnaire/list`;
  return await _request({
    method: 'GET',
    url
  });
}

// 咨询师更新个人信息
export async function updateConsultantInfo(data) {
  const url = `/consultant/info/update`;
  return await _request({
    method: 'PUT',
    url,
    data
  });
}

// 根据选择的量表生成task
export async function createFormTask(data) {
  const url = `/consultant/task/create`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// 查询任务详情
export async function getFormTaskList(taskId) {
  const url = `/consultant/task?taskId=${taskId}`;
  return await _request({
    method: 'GET',
    url
  });
}

// 查询任务详情
export async function getQuestionnaireUrl(params) {
  const url = `/consultant/questionnaireUrl${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  });
}

// 获取量表作答的链接地址
export async function startConsultantConsult(consultId) {
  const url = `/consultant/consult?consultId=${consultId}`;
  return await _request({
    method: 'GET',
    url
  });
}


// 根据选择的量表生成task
export async function clearUnreadMsg(data) {
  const url = `/consultant/chat/clear`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

/**
 *  咨询师打开和来访者的聊天窗口 时调用 动作触发
 * @param {*} data: triggerType  chatAuthId time
 * @returns 
 */
export async function consultantTrigger(data) {
  const url = `/consultant/trigger`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

/**
 *  咨询师分页查询咨询记录列表
 * @param {*} params 
 * @returns 
 */
export async function getConsultationRecord(params) {
  const url = `/consultant/consultationRecord/page${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

/**
 *  咨询师查询记录详情
 * @param {*} params  recordId
 * @returns 
 */
export async function getConsultationRecordDetail(params) {
  const url = `/consultant/consultationRecord/${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// 咨询师新增记录列表
export async function createConsultationRecord(params) {
  const url = `/consultant/consultationRecord/create`;
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// 咨询师新增记录列表
export async function updateConsultationRecord(params) {
  const url = `/consultant/consultationRecord/update`;
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

//工单列表
export async function getConsultantWorkOrders(params) {
  return await _request({
    method: 'GET',
    url: `/consultant/workOrders${_getQuerystr(params)}`
  });
}

// 咨询师获取工单详情
export async function getConsultantWorkOrder(workOrderId) {
  return await _request({
    method: 'GET',
    url: `/consultant/workOrder/${workOrderId}`
  });
}

// 咨询师获取工单消息列表
export async function getConsultantWorkOrderMessages(params) {
  return await _request({
    method: 'GET',
    url: `/consultant/workOrder/messages${_getQuerystr(params)}`
  });
}

// 咨询师接取工单
export async function takeWorkOrder(workOrderId) {
  return await _request({
    method: 'POST',
    url: `/consultant/workOrder/take/${workOrderId}`
  });
}

// 咨询师完成工单
export async function completeWorkOrder(workOrderId) {
  return await _request({
    method: 'POST',
    url: `/consultant/workOrder/complete/${workOrderId}`
  });
}

// 咨询师释放工单
export async function releaseWorkOrder(workOrderId) {
  return await _request({
    method: 'POST',
    url: `/consultant/workOrder/release/${workOrderId}`
  });
}

// 咨询师完成预约
export async function doctorCompleteAppoint(appointId) {
  return await _request({
    method: 'POST',
    url: `/consultant/appoint/${appointId}/completeAppoint`
  });
}
